/**
 * @generated SignedSource<<8e064e9ad1cd59854d7be7e3d5d9c559>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendRecommenderFeedbackInput = {
  recommendationInstanceId?: number | null;
  contextId?: number | null;
  recommendationId?: number | null;
  feedbackValue?: number | null;
  generation?: number | null;
  timeStep?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type sendRecommenderFeedbackMutation$variables = {
  input: SendRecommenderFeedbackInput;
};
export type sendRecommenderFeedbackMutation$data = {
  readonly sendRecommenderFeedback: {
    readonly clientMutationId: string | null;
  } | null;
};
export type sendRecommenderFeedbackMutation = {
  variables: sendRecommenderFeedbackMutation$variables;
  response: sendRecommenderFeedbackMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendRecommenderFeedbackPayload",
    "kind": "LinkedField",
    "name": "sendRecommenderFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendRecommenderFeedbackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendRecommenderFeedbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "49fa70dc6066c8ca993728b58bce7125",
    "id": null,
    "metadata": {},
    "name": "sendRecommenderFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation sendRecommenderFeedbackMutation(\n  $input: SendRecommenderFeedbackInput!\n) {\n  sendRecommenderFeedback(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "94eb2c2bb2eac2a3fbf92b73d5a2f250";

export default node;
